import { useContext, useEffect } from 'react'

import { UserContext } from '../context/user'
import moment from 'moment'

export const useIntercom = () => {
    const initIntercom = (personId, intercomKey, email, firstName, lastName, phoneNumber) => {
        const bootParams = {
            app_id: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
            hide_default_launcher: false,
        }
        bootParams['user_id'] = `${process.env.NEXT_PUBLIC_ENVIRONMENT_NAME}-${personId}`
        bootParams['email'] = email
        bootParams['user_hash'] = intercomKey
        bootParams['name'] = `${firstName} ${lastName}`
        bootParams['created_at'] = moment().utc()
        bootParams['phone'] = phoneNumber

        typeof window?.Intercom !== 'undefined' && window.Intercom('update', bootParams)
    }

    return {
        initIntercom,
    }
}
